<template>
  <div>
    <AddRetainershipModal :company="company"></AddRetainershipModal>
    <AddNewRetainershipModal :company="company"></AddNewRetainershipModal>
    <EditCreditLimit
      :creditLimit="creditLimit"
      :email="email"
    ></EditCreditLimit>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.companyRetainership.title") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/share.svg" width="80%" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ retainershipCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-5 text-center section___column_1">
                <button
                  class="add__new__retainership_btn"
                  @click="showAddRetainershipModal"
                >
                  {{ $t("text.companyRetainership.addExisting") }}
                  <img
                    src="@/assets/img/paper-plane.png"
                    width="30px"
                    class="ml-3"
                  />
                </button>
              </div>

              <div class="col-md-7 text-center section___column_1">
                <button
                  class="add__new__retainership_btn"
                  @click="showAddNewRetainershipModal"
                >
                  {{ $t("text.companyRetainership.addNew") }}
                  <img
                    src="@/assets/img/paper-plane.png"
                    width="30px"
                    class="ml-3"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class="position-relative">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="50" headerText="#"></e-column>
                <e-column
                  field="firstName"
                  width="200"
                  :headerText="$t('text.companyRetainership.firstName')"
                ></e-column>
                <e-column
                  field="lastName"
                  width="200"
                  :headerText="$t('text.companyRetainership.lastName')"
                ></e-column>
                <e-column
                  field="email"
                  width="270"
                  :headerText="$t('text.companyRetainership.email')"
                ></e-column>
                <e-column
                  field="balance"
                  width="200"
                  format="N2"
                  :headerText="$t('text.companyRetainership.balance')"
                ></e-column>
                <e-column
                  field="creditLimit"
                  width="150"
                  format="N2"
                  :headerText="$t('text.companyRetainership.creditLimit')"
                ></e-column>
                <e-column
                  field="loyaltyPoints"
                  width="150"
                  format="N2"
                  :headerText="$t('text.companyRetainership.loyaltyPts')"
                ></e-column>

                <!-- <e-column
                  width="400"
                  :template="buttonsTemplate"
                  headerText="Actions"
                ></e-column> -->
                <e-column width="60" :template="optionsTemplate"></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
            <DropDown :details="details" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import AddRetainershipModal from "@/components/modals/addRetainershipModal";
import AddNewRetainershipModal from "@/components/modals/addNewRetainershipModal";
import EditCreditLimit from "@/components/modals/Retainership/editCreditLimit";
import DropDown from "@/components/Templates/Dropdown/companyRetainershipDropdown.vue";
import RetTemp from "@/components/Templates/companyRetainershipTemplate.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Retainership :: Epump Portal",
  name: "Retainership",
  components: {
    MasterLayout,
    AddRetainershipModal,
    AddNewRetainershipModal,
    EditCreditLimit,
    TableLoader,
    DropDown,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      corpId: null,
      backgroundUrl,
      cardBackgroundUrl,
      fuelBalance: 0,
      walletTransactions: null,
      showLoader: false,
      totalTransactions: null,
      tableDataCount: 10,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      retainerships: null,
      retainershipCount: 0,
      creditLimit: "",
      email: "",
      company: null,
      details: {
        data: { status: "" },
        queryStrings: { id: "", companyId: this.$route.query.companyId },
        info: [
          {
            name: this.$t("text.assets.updateCreditLimit"),
            emitName: "updateCreditLimit",
          },
          {
            name: this.$t("text.assets.walletTransactions"),
            emitName: "walletTransactions",
          },
        ],
        delete: {
          hasDelete: false,
          deleteName: "deleteInvoice",
          name: "Delete",
          query: "id",
        },
      },
      optionsTemplate: function () {
        return {
          template: RetTemp,
        };
      },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div>
                <button class="zone_action_buttons edit_category" v-on:click="editCreditLimit(data.creditLimit, data.email)">{{data.editButton}}</button> 
                <a :href="'/Company/retainership/wallet-transactions?id=' + data.id + '&walletId=' + data.walletId + '&name=' + data.firstName" class="zone_action_buttons delete_category" v-on:click="changeRetainership($event, 'RetainershipWalletTransactions', data.id, data.walletId, data.firstName)">{{data.walletTransactionsButton}}</a>
                </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              changeRetainership($event, route, id, walletId, name) {
                $event.preventDefault();
                this.$eventHub.$emit(
                  "changeRetainership",
                  route,
                  id,
                  walletId,
                  name
                );
              },
              editCreditLimit(creditLimit, email) {
                this.$eventHub.$emit("setCreditLimit", creditLimit, email);
                this.$modal.show("editCreditLimit");
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getRetainerships();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getRetainerships();
    }
    this.$eventHub.$on("companyRetainershipData", (data) => {
      this.details.data = data;
      this.details.queryStrings.id = data.id;
      this.details.queryStrings.walletId = data.walletId;
      this.details.queryStrings.name = data.firstName;

      const option = document.getElementById("myDropdown");
      option.classList.add("show");

      let index;

      if (data.index > 10 && parseInt(data.index.toString().slice(1)) === 0) {
        index = 10;
      }
      if (data.index > 10 && parseInt(data.index.toString().slice(1)) > 0) {
        index = parseInt(data.index.toString().slice(1));
      }

      if (data.index <= 10) {
        index = data.index;
      }

      option.style.top = `${(80 * index + (85 - index * 2)).toString()}px`;
    });

    this.$eventHub.$on(this.details.info[0].emitName, (queryStrings) => {
      this.updateCreditLimit();
    });

    this.$eventHub.$on(this.details.info[1].emitName, (queryStrings) => {
      this._walletTransactions(queryStrings);
    });
    this.$eventHub.$on("getRetainerships", () => {
      this.getRetainerships();
    });
    this.$eventHub.$on("changeRetainership", (route, id, walletId, name) => {
      this.changeRoute(route, id, walletId, name);
    });
    this.$eventHub.$on("setCreditLimit", (creditLimit, email) => {
      this.creditLimit = creditLimit;
      this.email = email;
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("getRetainerships");
    this.$eventHub.$off("changeRetainership");
    this.$eventHub.$off("setCreditLimit");
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    _walletTransactions(queryStrings) {
      this.changeRoute(
        "RetainershipWalletTransactions",
        queryStrings.id,
        queryStrings.walletId,
        queryStrings.name
      );
    },
    updateCreditLimit() {
      this.$eventHub.$emit(
        "setCreditLimit",
        this.details.data.creditLimit,
        this.details.data.email
      );
      this.$modal.show("editCreditLimit");
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    changeRoute($newRoute, id, walletId, name) {
      this.$router.push({
        name: $newRoute,
        query: {
          id: id,
          walletId,
          name,
          companyId: this.$route.query.companyId,
        },
      });
    },
    showFundWalletModal() {
      this.$modal.show("fund-wallet-payweall");
    },
    showAddRetainershipModal() {
      this.$modal.show("addRetainershipModal");
    },
    showAddNewRetainershipModal() {
      this.$modal.show("addNewRetainershipModal");
    },
    getFuelBalance() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Wallet/Balance?id=${this.corpId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.fuelBalance = response.data.balance
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
        .catch((error) => {});
    },
    getRetainerships() {
      let companyID;
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/CorporateCustomers/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.sort((a, b) => {
            if (a.firstName && b.firstName) {
              return a.firstName.toLowerCase() > b.firstName.toLowerCase()
                ? 1
                : a.firstName.toLowerCase() < b.firstName.toLowerCase()
                ? -1
                : 0;
            }
          });
          response.data.forEach((retainership) => {
            index++;
            retainership.index = index;
            retainership.editButton = this.$t("text.actionButtons.edit");
            retainership.walletTransactionsButton = this.$t(
              "text.companyRetainership.walletTransactions"
            );
          });
          this.showLoader = false;
          grid.ej2Instances.setProperties({ dataSource: response.data });
          this.refreshGrid();
          this.retainershipCount = response.data.length;
        })
        .catch((error) => {});
    },
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .addNewRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    top: 150px !important;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
    overflow: auto;
  }
  .addRetainershipModal .v--modal-box.v--modal {
    margin: 0 auto;
    /* top: 88px !important; */
    width: 90% !important;
    height: 379px !important;
    left: 0 !important;
    overflow: auto;
  }
  button.add_quick_fuel_btn {
    margin-bottom: 62px;
  }
}
</style>
